import React from 'react';
import Icon from '@minecraft.icon';
import { DetailTextLarge, FlexRow } from '../../atoms';

export const PrimaryPhotoTag = ({ label }: { label: string }) => (
  <FlexRow
    bgColor="primary"
    borderPlacement="all"
    borderSize={0.067}
    borderRadius="xl"
    borderColor="primary"
    alignItems="center"
    className="cn_atom_px-3 cn_atom_py-1 cn_shadow-md"
    gap="2"
    grow={0}
    textColor="inverted"
  >
    <Icon name="on-avail" inheritColor size="ssm" />
    <DetailTextLarge color="inherit" fontWeight="semibold">
      {label}
    </DetailTextLarge>
  </FlexRow>
);
